// Transforms the oauth/v2/application-authorizations response into the shape of the v1 response
const transformAuthorizeResponseToLegacy = ({
  scopeGroups,
  appId,
  clientId,
  name,
  iconUrl,
  previouslyAuthorizedByUser
}) => ({
  scopeGroups,
  appId,
  clientId,
  name,
  shortDescription: '',
  description: '',
  // in v1, listingIconUrl is the app icon, in v2: iconUrl is the app icon
  listingIconUrl: iconUrl || undefined,
  authorized: previouslyAuthorizedByUser
});
export default transformAuthorizeResponseToLegacy;